import { uniqueId } from "lodash-es";
import type { Group, TrackType } from "./Base";

export interface PicInPicMaterial {
  id: string;
  name?: string;
  filter?: number;
  volumn?: number;
  noise?: boolean; // 降噪
  amplify?: boolean; // 增强
  soft?: number;
  centerX?: number;
  centerY?: number;
  fadeIn?: number;
  fadeOut?: number;

  rotate?: number;
  scale?: number; // 缩放
  times?: number; // 倍数
  duration?: number;
}
/**
 * 解析文件不能放在片段中：
 * 1. 文件解析是一个耗时操作，需要提前解析好，然后传递给片段
 * 2. 文件可能是网络资源，也可能是本地资源，在片段对象中要收束
 * 3. 不同片段可能共享同一个文件，解析一次即可
 * 4. 片段信息需要转换为文本进行存储（草稿）
 */
export class PicInPicGroup implements Group {
  id: string;
  type: TrackType = "picInPic";
  materials: PicInPicMaterial[];
  activeSourceIndex: number;
  name: string;
  frameCount: number;
  start: number;
  end: any;
  offsetL: number;
  offsetR: number;

  constructor(
    materials: PicInPicMaterial[],
    options: { start?: number; frameCount?: number }
  ) {
    // 设置ID
    this.id = uniqueId();
    // 设置图片信息
    this.materials = materials;
    // 获取文件名称
    this.name = "画中画";
    // 获取文件类型
    // 设置轨道信息
    this.frameCount = options.frameCount ?? 30 * 5;
    this.start = options.start ?? 0;
    this.end = this.start + this.frameCount;
  }
}
